
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bZMnB", function(module, exports) {
var $55ceb08e10dcc2d0$export$c90526da16c2eaaa = /*#__PURE__*/ function(SainAction) {
    SainAction["SOURCE_CLICKED"] = "sourceLinkClicked";
    SainAction["POSITIVE_FEEDBACK_PROVIDED"] = "positiveFeedbackProvided";
    SainAction["NEGATIVE_FEEDBACK_PROVIDED"] = "negativeFeedbackProvided";
    SainAction["DWELL_REACHED"] = "dwellTimeReached";
    SainAction["COPY_CLICKED"] = "copyButtonClicked";
    SainAction["FOLLOWUP_CLICKED"] = "followupLinkClicked";
    SainAction["ERROR_STATE_SUGGESTED_QUERY_CLICKED"] = "errorStateSuggestedQueryClicked";
    SainAction["OPEN_CHAT_CLICKED"] = "openChatButtonClicked";
    SainAction["EXPAND_CLICKED"] = "expandButtonClicked";
    SainAction["READ_MORE_BUTTON_CLICKED"] = "readMoreButtonClicked";
    SainAction["TOPIC_CLICKED"] = "topicClicked";
    SainAction["RECENT_WORK_CLICKED"] = "recentWorkClicked";
    SainAction["COLLABORATOR_CLICKED"] = "collaboratorClicked";
    SainAction["VIEW_PROFILE_CLICKED"] = "viewProfileClicked";
    SainAction["TEAM_MEMBER_CLICKED"] = "teamMemberClicked";
    SainAction["TEAM_LIST_CLICKED"] = "teamListClicked";
    SainAction["TEAM_LIST_ITEM_CLICKED"] = "teamListItemClicked";
    SainAction["VIEW_TEAM_PAGE_CLICKED"] = "viewTeamPageClicked";
    SainAction["REPORTING_LINES_CLICKED"] = "reportingLinesClicked";
    SainAction["PERSON_SELECTED"] = "cardClicked";
    SainAction["BOOKMARK_CLICKED"] = "bookmarkClicked";
    SainAction["CHAT_CLICKED"] = "chatClicked";
    SainAction["JIRA_ISSUE_CLICKED"] = "jiraIssueCardClicked";
    SainAction["VIEW_ALL_SOURCES"] = "viewAllSourcesClicked";
    SainAction["JIRA_NL_TO_JQL_CLICKED"] = "jiraNlToJqlCardClicked";
    SainAction["JIRA_NL_TO_JQL_VIEW_ALL"] = "viewAllButtonClicked";
    SainAction["JIRA_NL_TO_JQL_WORK_ITEM_CLICKED"] = "workItemClicked";
    SainAction["SHOW_ON_GOOGLE_MAPS_CLICKED"] = "showOnGoogleMapsClicked";
    SainAction["TOPIC_KNOWLEDGE_CARD_CLICKED"] = "topicKnowledgeCardClicked";
    SainAction["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "navigationalSearchResultCardClicked";
    SainAction["FMP_DWELL_START"] = "fmpDwellStart";
    SainAction["FMP_DWELL_START_EXPANDED"] = "fmpDwellStartExpanded";
    SainAction["FMP_DWELL_REACHED"] = "fmpDwellReached";
    SainAction["FMP_RESULT_EXITED"] = "fmpDwellExited";
    SainAction["AI_MODE_FOLLOWUP_CLICKED"] = "aiModeFollowupLinkClicked";
    SainAction["SHOW_MORE_TOPICS_CLICKED"] = "showMoreTopicsClicked";
    SainAction["DEFINITION_DWELL_MARKED"] = "definitionDwellMarked";
    SainAction["BLUE_LINK_CLICKED"] = "blueLinkClicked";
    SainAction["THIRD_PARTY_MESSAGE_CLICKED"] = "thirdPartyMessageClicked";
    return SainAction;
}({});
module.exports["SainAction"] = $55ceb08e10dcc2d0$export$c90526da16c2eaaa;

});

parcelRegister("eySxZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $cXLoX = parcelRequire("cXLoX");


var $4Tg3t = parcelRequire("4Tg3t");


var $iWa97 = parcelRequire("iWa97");


var $bZMnB = parcelRequire("bZMnB");

const $e5a6739eacc8a9a3$export$a0cb7cf9977bca78 = 3000;
const $e5a6739eacc8a9a3$export$bf85f2c6a4e29d4e = ()=>{
    const { trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)();
    // eslint-disable-next-line @atlaskit/platform/ensure-use-sync-external-store-server-snapshot
    (0, $cozmU.useSyncExternalStore)((0, $iWa97.subscribe), (0, $iWa97.getSnapshot));
    const fireSAINUsageEvent = (0, $cozmU.useCallback)(({ metCriteria: metCriteria, dwellTime: dwellTime, commonAttributes: commonAttributes, sourceProduct: sourceProduct })=>{
        const sanitizedCommonAttributes = commonAttributes ? (0, $4Tg3t.filterCommonAttributes)(commonAttributes) : {};
        // Handle FMP dwell cases - fire initial event with doesNotMeetMAUCriteria = true
        if (metCriteria === (0, $bZMnB.SainAction).FMP_DWELL_START || metCriteria === (0, $bZMnB.SainAction).FMP_DWELL_START_EXPANDED) {
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    mauEligibilityCriteria: metCriteria,
                    met_fmp_criteria: false,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $bZMnB.SainAction).FMP_DWELL_REACHED) {
            // If dwell time reaches threshold, fire second event (could eventually count as usage criteria)
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    dwellTime: dwellTime,
                    mauEligibilityCriteria: metCriteria,
                    met_fmp_criteria: true,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED) {
            // If dwell time reaches threshold, fire second event (could eventually count as usage criteria)
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    dwellTime: dwellTime,
                    sourceProduct: sourceProduct,
                    aiDwellTimeMilliSeconds: dwellTime,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $bZMnB.SainAction).FMP_RESULT_EXITED) {
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    action: metCriteria,
                    dwellTime: dwellTime,
                    sourceProduct: sourceProduct,
                    trackingMethod: 'fmp',
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria) {
            // If usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to false
            // only once per SAIN request
            const requestId = commonAttributes?.extraAttributes?.requestId;
            const doesNotMeetMAUCriteria = (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? requestId ? (0, $iWa97.getSnapshot)().has(requestId) : true // new behavior: need a requestId to meet MAU criteria to ensure only one MAU-met event is fired
             : false; // old behavior: always met MAU criteria
            trackAIResultView({
                doesNotMeetMAUCriteria: doesNotMeetMAUCriteria,
                attributes: {
                    dwellTime: dwellTime || 0,
                    mauEligibilityCriteria: metCriteria,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            if (!doesNotMeetMAUCriteria) (0, $iWa97.markFired)(requestId);
            // In addition, emit an action/feedback event for the action that was met
            // (https://hello.atlassian.net/wiki/x/Vxb5DAE)
            switch(metCriteria){
                case (0, $bZMnB.SainAction).SOURCE_CLICKED:
                case (0, $bZMnB.SainAction).COPY_CLICKED:
                case (0, $bZMnB.SainAction).FOLLOWUP_CLICKED:
                case (0, $bZMnB.SainAction).TOPIC_CLICKED:
                case (0, $bZMnB.SainAction).RECENT_WORK_CLICKED:
                case (0, $bZMnB.SainAction).COLLABORATOR_CLICKED:
                case (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED:
                case (0, $bZMnB.SainAction).TEAM_MEMBER_CLICKED:
                case (0, $bZMnB.SainAction).VIEW_TEAM_PAGE_CLICKED:
                case (0, $bZMnB.SainAction).OPEN_CHAT_CLICKED:
                case (0, $bZMnB.SainAction).JIRA_NL_TO_JQL_VIEW_ALL:
                case (0, $bZMnB.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED:
                case (0, $bZMnB.SainAction).VIEW_ALL_SOURCES:
                case (0, $bZMnB.SainAction).BLUE_LINK_CLICKED:
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            sourceProduct: sourceProduct,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED:
                    trackAIFeedbackSubmit('up', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED:
                    trackAIFeedbackSubmit('down', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $bZMnB.SainAction).AI_MODE_FOLLOWUP_CLICKED:
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            sourceProduct: sourceProduct,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                default:
                    break;
            }
        } else // If no usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to true
        trackAIResultView({
            doesNotMeetMAUCriteria: true,
            attributes: {
                dwellTime: dwellTime || 0,
                ...sanitizedCommonAttributes
            }
        });
    }, [
        trackAIResultView,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    return {
        fireSAINUsageEvent: fireSAINUsageEvent
    };
};
module.exports["SAIN_USAGE_DWELL_THRESHOLD"] = $e5a6739eacc8a9a3$export$a0cb7cf9977bca78;
module.exports["useSAINUsageCriteriaMet"] = $e5a6739eacc8a9a3$export$bf85f2c6a4e29d4e;

});

parcelRegister("iWa97", function(module, exports) {
const $34d7be492d39e63c$var$sainUsageEventStore = new Map();
const $34d7be492d39e63c$var$MAX_EVENTS = 10;
// React listeners for useSyncExternalStore
const $34d7be492d39e63c$var$listeners = new Set();
function $34d7be492d39e63c$var$emitChange() {
    $34d7be492d39e63c$var$listeners.forEach((listener)=>listener());
}
function $34d7be492d39e63c$export$ec068583843480e7(listener) {
    $34d7be492d39e63c$var$listeners.add(listener);
    return ()=>$34d7be492d39e63c$var$listeners.delete(listener);
}
function $34d7be492d39e63c$export$ab60d92959c37070() {
    return $34d7be492d39e63c$var$sainUsageEventStore;
}
function $34d7be492d39e63c$export$66247cb47ecd9c1b(requestId) {
    if (!$34d7be492d39e63c$var$sainUsageEventStore.has(requestId)) {
        $34d7be492d39e63c$var$sainUsageEventStore.set(requestId, true);
        if ($34d7be492d39e63c$var$sainUsageEventStore.size > $34d7be492d39e63c$var$MAX_EVENTS) {
            const oldestKey = $34d7be492d39e63c$var$sainUsageEventStore.keys().next().value;
            if (oldestKey) $34d7be492d39e63c$var$sainUsageEventStore.delete(oldestKey);
        }
        $34d7be492d39e63c$var$emitChange();
    }
}
module.exports["subscribe"] = $34d7be492d39e63c$export$ec068583843480e7;
module.exports["getSnapshot"] = $34d7be492d39e63c$export$ab60d92959c37070;
module.exports["markFired"] = $34d7be492d39e63c$export$66247cb47ecd9c1b;

});

parcelRegister("lelwR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $eDWBm = parcelRequire("eDWBm");


var $aMSTz = parcelRequire("aMSTz");


var $htnqN = parcelRequire("htnqN");


var $62kFU = parcelRequire("62kFU");


var $dcAFs = parcelRequire("dcAFs");


var $cuvLu = parcelRequire("cuvLu");


var $zzZbq = parcelRequire("zzZbq");


var $aTjYs = parcelRequire("aTjYs");


var $gVJti = parcelRequire("gVJti");

const $14367db50208fb8a$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m",
    readingAids: "_11c81d4k _ca0qutpp _u5f31ejb _n3tdutpp _19bv1ejb _syaz1tmo _p12fr5sb _c71luuw1 _18m91wug",
    nonReadingAids: "_11c8fhey _ca0qv47k _u5f31ejb _n3tdv47k _19bv1ejb _syaz1sqi _c71lq06n _18m91wug _1bsb1osq"
};
const $14367db50208fb8a$export$e926676385687eaf = ({ isReadingAids: isReadingAids, wrapper: wrapper, source: source, cloudId: cloudId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const DefaultWrapper = isReadingAids ? (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcAFs.ReadingAidsPopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $62kFU.ReadingAidsContainer), null, props.children)) : (0, $aMSTz.SearchDialog);
    const Wrapper = wrapper ? wrapper : DefaultWrapper;
    const logError = (0, $cozmU.useCallback)((error)=>{
        // Currently we are in between deprecating UFOv1 and adopting react-UFO  for platform packages, so this is a temporary way for us to collect error logs
        // https://atlassian.slack.com/archives/C01AY8132S3/p1716509785878689
        const errorAttributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1),
            isHello: (0, $aTjYs.isHello)(cloudId)
        };
        createAnalyticsEvent({
            action: 'failed',
            actionSubject: 'aiAnswerDialog',
            source: source || 'unknown',
            eventType: 'track',
            attributes: errorAttributes
        }).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
        if ((0, $iDrrr.fg)('kd_sain_error_boundary_shown_event')) createAnalyticsEvent({
            action: 'shown',
            actionSubject: 'aiAnswerError',
            source: source || 'unknown',
            eventType: 'track',
            attributes: {
                ...errorAttributes,
                errorState: (0, $htnqN.NLPSearchErrorState).RenderError
            }
        }).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
        (0, $cuvLu.logger).error({
            error: errorAttributes,
            functionName: 'ErrorBoundary: Depricated'
        });
    }, [
        source,
        createAnalyticsEvent,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($14367db50208fb8a$var$styles.root, isReadingAids ? $14367db50208fb8a$var$styles.root : $14367db50208fb8a$var$styles.readingAids)
        }, formatMessage((0, $gVJti.messages).error_boundary_fallback_text))),
        onException: logError
    }, children);
};
module.exports["ErrorBoundary"] = $14367db50208fb8a$export$e926676385687eaf;

});

parcelRegister("eDWBm", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $cozmU = parcelRequire("cozmU");

class $7b3dfa8de6f3510b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    componentWillUnmount() {
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(undefined);
    }
    render() {
        const { renderWithErrorInfo: RenderWithErrorInfo } = this.props;
        if (RenderWithErrorInfo && this.state.error && this.state.errorInfo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RenderWithErrorInfo, {
            error: this.state.error,
            errorInfo: this.state.errorInfo
        });
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = ()=>{
            this.setState({
                error: undefined,
                errorInfo: undefined
            });
        };
        this.state = {
            error: undefined,
            errorInfo: undefined
        };
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(this.resetErrorBoundary);
    }
}
module.exports["ErrorBoundary"] = $7b3dfa8de6f3510b$export$e926676385687eaf;

});

parcelRegister("62kFU", function(module, exports) {
/* reading-aids-container.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $43c2452d73591196$export$a9f6f8fd5598a12e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1kw7 _kqswh2mm _c71lstmo _1bsbdgin _bfhk1bhr _1reo15vq _18m915zi _1fjgglyw _4pckglyw _1cicglyw _e808etvb",
            __cmplp.className
        ])
    });
});
module.exports["ReadingAidsContainer"] = $43c2452d73591196$export$a9f6f8fd5598a12e;

});

parcelRegister("dcAFs", function(module, exports) {
/* reading-aids-popup-container.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $74af3b3d0be03000$export$f79f209cc21596d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, continueAnimation: continueAnimation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rywqsk": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.continueAnimation ? 'rotationAnimation linear 3s infinite' : ''),
            "--_8bhvpm": (0, $9aYkv.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            __cmplp.isLoading || __cmplp.continueAnimation ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1qi0 _1yt4v77o _y44v1rtw _11q71ggy _kqswh2mm _16qs130s",
            __cmplp.className
        ])
    });
});
module.exports["ReadingAidsPopupContainer"] = $74af3b3d0be03000$export$f79f209cc21596d;

});

parcelRegister("aTjYs", function(module, exports) {
const $5533ced57b27ed23$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
module.exports["isHello"] = $5533ced57b27ed23$export$8e3fc93123f96c19;

});

parcelRegister("gVJti", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4e7a34c8df556253$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    error_boundary_fallback_text: {
        id: "search_ai.error_boundary_fallback_text",
        defaultMessage: "Something went wrong. Try refreshing the page or trying again later."
    }
});
module.exports["messages"] = $4e7a34c8df556253$export$defe85febe8b728c;

});

parcelRegister("lPcf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eDWBm = parcelRequire("eDWBm");


var $cuvLu = parcelRequire("cuvLu");

const $eb3f7933f4ae0ee0$var$useLogException = ()=>{
    return (0, $cozmU.useCallback)(async (error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'useLogException'
        });
    }, []);
};
const $eb3f7933f4ae0ee0$export$e926676385687eaf = (props)=>{
    const onException = $eb3f7933f4ae0ee0$var$useLogException();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        ...props,
        onException: onException
    }, props.children);
};
module.exports["ErrorBoundary"] = $eb3f7933f4ae0ee0$export$e926676385687eaf;

});

parcelRegister("kisaw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gABt9 = parcelRequire("gABt9");


var $zzZbq = parcelRequire("zzZbq");

const $2158bd65b0fea07b$var$SearchTenantContextQuery = `
  query SearchTenantContextQuery($cloudId: ID!) {
    tenantContexts(cloudIds: [$cloudId]) {
      cloudUrl
    }
	}
`;
const $2158bd65b0fea07b$var$fetchTenantContext = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $2158bd65b0fea07b$var$SearchTenantContextQuery,
                variables: variables
            })
        }
    };
    return (0, $gABt9.utils).requestService({
        url: (0, $zzZbq.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};
const $2158bd65b0fea07b$export$28e7c557f4d454d9 = (cloudId)=>{
    const [tenantContext, setTenantContext] = (0, $cozmU.useState)({});
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const fetchContext = (0, $cozmU.useCallback)(async ()=>{
        try {
            const { data: data } = await $2158bd65b0fea07b$var$fetchTenantContext({
                cloudId: cloudId
            });
            if (data?.tenantContexts && data.tenantContexts.length > 0) setTenantContext(data.tenantContexts[0]);
            else setHasError(true);
        } catch (e) {
            setHasError(true);
        }
    }, [
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchContext();
    }, [
        fetchContext
    ]);
    return {
        tenantContext: tenantContext,
        hasError: hasError
    };
};
module.exports["useTenantContext"] = $2158bd65b0fea07b$export$28e7c557f4d454d9;

});

parcelRegister("br26d", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $3hVWe = parcelRequire("3hVWe");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $lPcf8 = parcelRequire("lPcf8");


var $kisaw = parcelRequire("kisaw");


var $hXc9i = parcelRequire("hXc9i");


var $fwt1L = parcelRequire("fwt1L");


var $2i5Nf = parcelRequire("2i5Nf");


var $agblG = parcelRequire("agblG");


var $kcKX3 = parcelRequire("kcKX3");


var $7EwcU = parcelRequire("7EwcU");

const $72912c5bf209e671$var$AITopicsByPersonComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ userId: userId, userName: userName, cloudId: cloudId, sessionId: sessionId, v2styles: v2styles = false })=>{
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { aiRelatedTopics: aiRelatedTopics, fetchRelatedTopics: fetchRelatedTopics, showTopics: showTopics } = (0, $7EwcU.useRelatedTopics)();
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [showMore, setShowMore] = (0, $cozmU.useState)(false);
    const { breakElems: breakElems } = (0, $kcKX3.useTopicBreakElems)(wrapperRef, showTopics);
    const { tenantContext: tenantContext } = (0, $kisaw.useTenantContext)(cloudId);
    const { cloudUrl: cloudUrl } = tenantContext;
    const onBadgeClickHandler = ({ topicId: topicId, position: position, shownAfterCardBodyExpanded: shownAfterCardBodyExpanded })=>{
        fireAnalyticsEvent((0, $2i5Nf.onRelatedEntityClick)({
            clickedEntityId: topicId,
            clickedEntityType: 'topic',
            principalEntityType: (0, $fwt1L.RelatedEntityType).USER,
            principalEntityId: userId,
            sessionId: sessionId,
            location: 'personCard',
            position: position,
            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).TOPIC_CLICKED,
            commonAttributes: commonAttributes
        });
    };
    const onShowMoreTopicsClick = ()=>{
        fireAnalyticsEvent((0, $2i5Nf.onToggleMoreRelatedEntitiesClick)({
            sessionId: sessionId,
            location: 'personCard',
            expanded: !showMore
        }));
        if (!showMore) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SHOW_MORE_TOPICS_CLICKED,
            commonAttributes: commonAttributes
        });
        setShowMore((s)=>!s);
    };
    (0, $cozmU.useEffect)(()=>{
        fetchRelatedTopics({
            entityId: userId,
            principalEntityType: (0, $fwt1L.RelatedEntityType).USER,
            cloudId: cloudId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (showTopics) fireAnalyticsEvent((0, $2i5Nf.onSurfaceShown)({
            principalEntityId: userId,
            principalEntityType: (0, $fwt1L.RelatedEntityType).USER,
            relatedTopics: aiRelatedTopics.map((topic)=>topic.id),
            sessionId: sessionId,
            location: 'personCard'
        }));
    }, [
        showTopics,
        aiRelatedTopics,
        userId,
        fireAnalyticsEvent,
        sessionId
    ]);
    const firstName = userName.split(' ')[0];
    return showTopics ? v2styles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        ref: wrapperRef,
        space: "space.100",
        rowSpace: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, (breakElems < 0 ? aiRelatedTopics : aiRelatedTopics.slice(0, Math.max(1, breakElems))).map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: `/wiki/topics/${topic.id}`,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: position,
                    shownAfterCardBodyExpanded: false
                })
        })), breakElems < aiRelatedTopics.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        onClick: ()=>(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? onShowMoreTopicsClick() : setShowMore((s)=>!s),
        icon: (iconProps)=>showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        label: showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $agblG.messages).ai_topics_show_fewer_topics_text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $agblG.messages).ai_topics_show_more_topics_text),
        spacing: "compact"
    }) : null), showMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.slice(breakElems).map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: cloudUrl ? `${cloudUrl}/wiki/topics/${topic.id}` : undefined,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: breakElems + position,
                    shownAfterCardBodyExpanded: true
                })
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $agblG.messages).ai_topics_surface_header_person,
        values: {
            userName: firstName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        rowSpace: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXc9i.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: cloudUrl ? `${cloudUrl}/wiki/topics/${topic.id}` : undefined,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: position,
                    shownAfterCardBodyExpanded: false
                })
        }))))) : null;
});
const $72912c5bf209e671$export$98ee922d18019998 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72912c5bf209e671$var$AITopicsByPersonComponent, props));
module.exports["AITopicsByPerson"] = $72912c5bf209e671$export$98ee922d18019998;

});

parcelRegister("hXc9i", function(module, exports) {
/* knowledge-badge.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $cozmU = parcelRequire("cozmU");


var $7ZB0A = parcelRequire("7ZB0A");


var $gznGh = parcelRequire("gznGh");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");

const $4e32f7a5738cba8e$var$styles = {
    knowledgeBadge: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _1e0c116y",
    buttonLink: "_ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _18u0v77o _2hwx1b66"
};
const $4e32f7a5738cba8e$export$7e867bde3d2da523 = ({ name: name, url: url, onBadgeClick: onBadgeClick = ()=>{} })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $4e32f7a5738cba8e$var$styles.knowledgeBadge,
        backgroundColor: "color.background.input"
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        href: url,
        appearance: "subtle",
        onClick: ()=>{
            onBadgeClick();
        },
        spacing: "none",
        target: "_blank"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $4e32f7a5738cba8e$var$styles.buttonLink
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gznGh))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), null, name))));
module.exports["KnowledgeBadge"] = $4e32f7a5738cba8e$export$7e867bde3d2da523;

});

parcelRegister("fwt1L", function(module, exports) {
var $8e8ce1cfbf72b105$export$ee18e55fb2f84827 = /*#__PURE__*/ function(RelatedEntityType) {
    RelatedEntityType["KEY_PHRASE"] = "KEY_PHRASE";
    RelatedEntityType["TOPIC"] = "TOPIC";
    RelatedEntityType["USER"] = "USER";
    RelatedEntityType["CONFLUENCE_DOCUMENT"] = "CONFLUENCE_DOCUMENT";
    RelatedEntityType["CONFLUENCE_PAGE"] = "CONFLUENCE_PAGE";
    RelatedEntityType["CONFLUENCE_BLOGPOST"] = "CONFLUENCE_BLOGPOST";
    return RelatedEntityType;
}({});
module.exports["RelatedEntityType"] = $8e8ce1cfbf72b105$export$ee18e55fb2f84827;

});

parcelRegister("2i5Nf", function(module, exports) {

var $cuvLu = parcelRequire("cuvLu");

const $683e2b07cbdf088e$export$1e54b1f2535dc14e = (surfaceAttributes)=>{
    try {
        return {
            action: 'shown',
            actionSubjectId: 'aiTopic',
            actionSubject: 'surface',
            eventType: 'track',
            attributes: {
                ...surfaceAttributes
            }
        };
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onSurfaceShown'
        });
        return {};
    }
};
const $683e2b07cbdf088e$export$9eff5105a9d90d9e = (entityClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: 'relatedEntity',
            eventType: 'ui',
            attributes: {
                ...entityClickAttributes
            }
        };
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onRelatedEntityClick'
        });
        return {};
    }
};
const $683e2b07cbdf088e$export$fbceb4fd6d209a9a = (showMoreRelatedEntitiesClickedAttributes)=>{
    return {
        action: 'clicked',
        actionSubjectId: 'aiTopic',
        actionSubject: 'toggleMoreRelatedEntities',
        eventType: 'ui',
        attributes: {
            ...showMoreRelatedEntitiesClickedAttributes
        }
    };
};
module.exports["onSurfaceShown"] = $683e2b07cbdf088e$export$1e54b1f2535dc14e;
module.exports["onRelatedEntityClick"] = $683e2b07cbdf088e$export$9eff5105a9d90d9e;
module.exports["onToggleMoreRelatedEntitiesClick"] = $683e2b07cbdf088e$export$fbceb4fd6d209a9a;

});

parcelRegister("agblG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f137acf5ce5ba150$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_topics_surface_header_user: {
        id: "search_ai.ai_topics.surface.header",
        defaultMessage: "Topics this person knows about"
    },
    ai_topics_surface_header_generic: {
        id: "search_ai.ai_topics.related_topics.header",
        defaultMessage: "Related topics"
    },
    ai_topics_surface_header_person: {
        id: "search_ai.ai_topics.surface.person_header",
        defaultMessage: "Topics {userName} knows about"
    },
    ai_topics_surface_header_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.header_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.footer_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_content_may_vary: {
        id: "search_ai.ai_topics.related_topics.footer_content_may_vary",
        defaultMessage: "Content quality may vary"
    },
    ai_topics_surface_footer_powered_by_ai: {
        id: "search_ai.ai_topics.related_topics.footer_powered_by_ai",
        defaultMessage: "Powered by AI"
    },
    ai_topics_user_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.user",
        defaultMessage: "Are these topics correctly associated with this user?"
    },
    ai_topics_page_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.page",
        defaultMessage: "Do these topics accurately reflect the contents of this page?"
    },
    ai_topics_page_feedback_button_text: {
        id: "search_ai.ai_topics.feedback.prompt.button",
        defaultMessage: "Submit feedback"
    },
    ai_topics_profile_feedback_text: {
        id: "search_ai.ai_topics.profile.prompt",
        defaultMessage: "Do these topics look accurate for this person?"
    },
    ai_topics_card_header_text: {
        id: "search_ai.ai_topics.card.header",
        defaultMessage: "Topics related to \"{searchQuery}\""
    },
    ai_topics_card_feedback_prompt: {
        id: "search_ai.ai_topics.card.feedback_prompt",
        defaultMessage: "Are these relevant to your search?"
    },
    ai_topics_rovo_branding_text: {
        id: "search_ai.ai_topics.rovo_branding_text",
        defaultMessage: "Rovo"
    },
    ai_topics_show_more_topics_text: {
        id: "search_ai.ai_topics.show_more_topics_text",
        defaultMessage: "Show more topics"
    },
    ai_topics_show_fewer_topics_text: {
        id: "search_ai.ai_topics.show_fewer_topics_text",
        defaultMessage: "Show fewer topics"
    }
});
module.exports["messages"] = $f137acf5ce5ba150$export$defe85febe8b728c;

});

parcelRegister("kcKX3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b366b346be0bef0b$var$BUTTON_WIDTH = 20;
const $b366b346be0bef0b$var$PADDING_BLOCK_END = 16;
const $b366b346be0bef0b$var$TOPIC_INLINE_SPACE = 8;
const $b366b346be0bef0b$export$6e050707ceb5a52f = (wrapperRef, showTopics)=>{
    const [breakElems, setBreakElems] = (0, $cozmU.useState)(-1);
    const [topicLengths, setTopicLengths] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((topics)=>{
            const wrapper = topics[0];
            const cwidth = wrapper.target.clientWidth;
            const tl = topicLengths;
            var runningWidth = 0;
            var elemsHold = 0;
            // on first run, all topics are displayed so we can loop through and get the lengths
            if (tl.length === 0) for (const topic of Array.from(wrapper.target.children)){
                const width = topic.scrollWidth;
                tl.push(width);
            }
            for(let i = 0; i < tl.length; i++){
                const width = topicLengths[i];
                if (runningWidth + width + $b366b346be0bef0b$var$PADDING_BLOCK_END + $b366b346be0bef0b$var$BUTTON_WIDTH <= cwidth) elemsHold += 1;
                runningWidth += width + $b366b346be0bef0b$var$TOPIC_INLINE_SPACE;
            }
            setBreakElems(elemsHold);
            // on first run, save the topic lengths so we can reuse
            if (topicLengths.length === 0) setTopicLengths(tl);
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showTopics
    ]);
    return {
        breakElems: breakElems
    };
};
module.exports["useTopicBreakElems"] = $b366b346be0bef0b$export$6e050707ceb5a52f;

});

parcelRegister("7EwcU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6JEx2 = parcelRequire("6JEx2");


var $lOW3O = parcelRequire("lOW3O");


var $aiuiD = parcelRequire("aiuiD");


var $fwt1L = parcelRequire("fwt1L");

const $254b85def434a166$export$b08faa9b0d12bdd8 = 'atlassian.search-dialog.ai-topics-component';
const $254b85def434a166$export$977fb96428acdf48 = ()=>{
    const [aiRelatedTopics, setAIRelatedTopics] = (0, $cozmU.useState)([]);
    const [error, setError] = (0, $cozmU.useState)('');
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const fetchRelatedTopics = async ({ entityId: entityId, cloudId: cloudId, principalEntityType: principalEntityType })=>{
        if (!entityId) {
            setAIRelatedTopics([]);
            return;
        }
        const cache = JSON.parse((0, $6JEx2.getSessionItem)($254b85def434a166$export$b08faa9b0d12bdd8) || '{}');
        if (cache?.entityId === entityId) setAIRelatedTopics(cache.topics);
        else {
            setAIRelatedTopics([]);
            (0, $6JEx2.deleteSessionItem)($254b85def434a166$export$b08faa9b0d12bdd8);
            setIsLoading(true);
            try {
                const { data: data } = await (0, $lOW3O.fetchRelatedEntities)({
                    entityId: entityId,
                    entityType: principalEntityType,
                    relatedEntityType: (0, $fwt1L.RelatedEntityType).TOPIC,
                    cloudId: cloudId,
                    first: 5
                });
                if (data.knowledgeDiscovery.__typename === (0, $aiuiD.RelatedEntitiesResult).QueryError) setError('REQUEST_ERROR');
                else if (data.knowledgeDiscovery.relatedEntities?.nodes) {
                    const entities = data.knowledgeDiscovery.relatedEntities.nodes;
                    setAIRelatedTopics(entities);
                    (0, $6JEx2.setSessionItem)($254b85def434a166$export$b08faa9b0d12bdd8, JSON.stringify({
                        entityId: entityId,
                        topics: entities
                    }));
                }
            } catch  {
                setError('NETWORK_ERROR');
            } finally{
                setIsLoading(false);
            }
        }
    };
    const resetTopics = (0, $cozmU.useCallback)(()=>{
        setAIRelatedTopics([]);
    }, [
        setAIRelatedTopics
    ]);
    const showTopics = !isLoading && !error && aiRelatedTopics.length > 0;
    return {
        aiRelatedTopics: aiRelatedTopics,
        fetchRelatedTopics: fetchRelatedTopics,
        showTopics: showTopics,
        resetTopics: resetTopics
    };
};
module.exports["useRelatedTopics"] = $254b85def434a166$export$977fb96428acdf48;

});

parcelRegister("lOW3O", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $zzZbq = parcelRequire("zzZbq");


var $84bzL = parcelRequire("84bzL");

const $b206aa7741ad2572$export$a6a63d73bee8e09d = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: (0, $84bzL.RelatedEntitiesQuery),
                variables: variables
            })
        },
        queryParams: {
            q: 'RelatedEntities'
        }
    };
    return (0, $gABt9.utils).requestService({
        url: (0, $zzZbq.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};
module.exports["fetchRelatedEntities"] = $b206aa7741ad2572$export$a6a63d73bee8e09d;

});

parcelRegister("84bzL", function(module, exports) {
const $da7892fe0a7ba62e$export$da4042a87a471c60 = `
  query RelatedEntities(
    $entityId: String!
    $entityType: KnowledgeDiscoveryEntityType!
    $relatedEntityType: KnowledgeDiscoveryEntityType!
    $cloudId: String!
    $first: Int
    $after: String
  ) {
    knowledgeDiscovery {
      relatedEntities(
        entityId: $entityId
        entityType: $entityType
        relatedEntityType: $relatedEntityType
        cloudId: $cloudId
        first: $first
        after: $after
      ) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
        ... on KnowledgeDiscoveryRelatedEntityConnection {
          __typename
          nodes {
            ... on KnowledgeDiscoveryTopic {
              id
              name
              description
              documentCount
              updatedAt
              type
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
        ... on QueryError {
          message
        }
      }
    }
  }
`;
module.exports["RelatedEntitiesQuery"] = $da7892fe0a7ba62e$export$da4042a87a471c60;

});

parcelRegister("aiuiD", function(module, exports) {
var $0f20332e4211008a$export$e11ed46440979a9c = /*#__PURE__*/ function(RelatedEntitiesResult) {
    RelatedEntitiesResult["KnowledgeDiscoveryRelatedEntityConnection"] = "KnowledgeDiscoveryRelatedEntityConnection";
    RelatedEntitiesResult["QueryError"] = "QueryError";
    return RelatedEntitiesResult;
}({});
module.exports["RelatedEntitiesResult"] = $0f20332e4211008a$export$e11ed46440979a9c;

});


//# sourceMappingURL=definition-popup-content.86a9eb5d.js.map
